import { surfaceHref } from '../../app/surface';
import { SITE_NAME, SITE_TAGLINE } from '../../app/site-config';
import { QuickBugReportButton } from '../bug-report/QuickBugReportButton';

const links = [
  ['Conócenos', surfaceHref('home', '/post/web/acerca-de')],
  ['Preguntas frecuentes', surfaceHref('home', '/post/web/preguntas-frecuentes')],
  ['Métodos de pago', surfaceHref('home', '/post/web/metodos-pago')],
] as const;

export function SiteFooter() {
  return (
    <footer className="site-footer" aria-label="Pie de página">
      <div className="container py-4">
        <nav aria-label={SITE_NAME}>
          <ul className="footer-links list-unstyled mb-0">
            {links.map(([label, href]) => <li key={label}><a href={href}>{label}</a></li>)}
          </ul>
        </nav>

        <p className="mt-3 mb-0">
          <QuickBugReportButton />
        </p>

        <p className="mt-4 mb-1">© {new Date().getFullYear()} <strong>{SITE_NAME}</strong>. Todos los derechos reservados.</p>
        <p className="footer-note mb-0">{SITE_TAGLINE}</p>
      </div>
    </footer>
  );
}
